import { FC } from "react";
import {
	FilledInput,
	FormControl,
	Input,
	MenuItem,
	OutlinedInput,
	Select,
	SelectChangeEvent,
	Stack,
	Typography,
} from "@mui/material";
import { ArrowDropdown } from "../../../assets/icons";

export interface DropdownSelectObject {
	key: string;
	label: string;
}

export interface DropdownSelectType {
	dropdownItems: DropdownSelectObject[];
	value: string;
	loading?: boolean;
	onChange: (key: string) => void;
	text?: string;
	variant: "filled" | "outlined" | "standard";
}

const DropdownSelect: FC<DropdownSelectType> = ({ dropdownItems, value, loading = false, onChange, text, variant }) => {
	const handleChange = (event: SelectChangeEvent<string>) => {
		onChange(event.target.value);
	};

	return (
		<Stack direction="row" alignItems="center" spacing={1}>
			{text && <Typography variant="subtitle1">{text}</Typography>}

			<FormControl size="small" disabled={loading}>
				<Select
					value={value}
					onChange={handleChange}
					variant={variant}
					IconComponent={ArrowDropdown}
					input={
						variant === "standard" ? (
							<Input disableUnderline /> // standard variant: disable underline
						) : variant === "outlined" ? (
							<OutlinedInput /> // outlined variant: default outlined input
						) : (
							<FilledInput /> // filled variant: default filled input
						)
					}
					sx={{
						p: 1,
						"& .MuiSelect-select": {
							padding: 0,
							lineHeight: "1em",
							display: "flex",
							alignItems: "center",
							mt: "2px",
						},
					}}
				>
					{dropdownItems.map((item) => (
						<MenuItem key={item.key} value={item.key}>
							<Typography variant="body2" fontWeight={600} color="text.secondary">
								{item.label}
							</Typography>
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Stack>
	);
};

export default DropdownSelect;
